import React from 'react';
import constants from 'constants';

const {
  CPD_STATUSES
} = constants;

function CPDPoints({
  webinar,
  className = '',
  style = {}
}) {
  return <p style={style} className={className}>
    CPD Points: {cpdPoints(webinar)}
  </p>
}

function cpdPoints(webinar) {
  const { cpd_status, int_cpd_points, ext_cpd_points, cpd_points } = webinar;

  if (cpd_status === CPD_STATUSES.granted) {
    switch (cpd_points) {
      case 'internal':
        return `${int_cpd_points || 0} Int`
      case 'external':
        return `${ext_cpd_points || 0} Ext`
      case 'both':
        return `${int_cpd_points || 0} Int, ${ext_cpd_points || 0} Ext`
      default:
        return 'sda';
    }
  }

  switch (cpd_status) {
    case CPD_STATUSES.applied_for:
      return 'Applied for'
    case CPD_STATUSES.not_applicable:
      return 'Not applicable in the cpd locker'
    default:
  }
}

export {
  cpdPoints,
  CPDPoints
}



/** WEBPACK FOOTER **
 ** ./src/components/CPDPoints/index.js
 **/